import { useEffect, useState } from "react";

// Persists the cooldown's END time (not the remaining seconds), so a page reload resumes the
// countdown instead of resetting it. An expired timestamp reads back as 0, so a stale key is
// harmless and never needs cleanup. The backend enforces the limit regardless — this only keeps
// the button from inviting a call that would come back 429.
export function useCooldown(key) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const until = Number(localStorage.getItem(key) ?? 0);
    setSeconds(Math.max(0, Math.ceil((until - Date.now()) / 1000)));
  }, [key]);

  useEffect(() => {
    if (seconds <= 0) {
      return undefined;
    }

    const timer = setTimeout(() => setSeconds(seconds - 1), 1000);

    return () => clearTimeout(timer);
  }, [seconds]);

  const start = (value) => {
    localStorage.setItem(key, String(Date.now() + value * 1000));
    setSeconds(value);
  };

  return { seconds, start };
}
